/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SAVE_USER = exports.SAVE_USER = 'SAVE_USER';
var DELETE_USER = exports.DELETE_USER = 'DELETE_USER';

var FETCH_POSTS_REQUEST = exports.FETCH_POSTS_REQUEST = 'FETCH_POSTS_REQUEST';
var FETCH_POSTS_FAILURE = exports.FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';
var FETCH_POSTS_SUCCESS = exports.FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';

var REQUEST_POSTS = exports.REQUEST_POSTS = 'REQUEST_POSTS';
var RECEIVE_POSTS = exports.RECEIVE_POSTS = 'RECEIVE_POSTS';

var ADD = exports.ADD = 'ADD';
var MINUS = exports.MINUS = 'MINUS';

//设备管理
var DEVICE_FECTH_PRDOCUT_DETAIL = exports.DEVICE_FECTH_PRDOCUT_DETAIL = 'DEVICE_FECTH_PRDOCUT_DETAIL';
var ADD_DEVICE = exports.ADD_DEVICE = 'ADD_DEVICE';
var EDITE_DEVICE = exports.EDITE_DEVICE = 'EDITE_DEVICE';
var DELETE_DEVICE = exports.DELETE_DEVICE = 'DELETE_DEVICE';
var GET_DEVICE_LIST = exports.GET_DEVICE_LIST = 'GET_DEVICE_LIST';
var GET_DEVICE_DETAIL = exports.GET_DEVICE_DETAIL = 'GET_DEVICE_DETAIL';
var GET_DEVICE_TYPE = exports.GET_DEVICE_TYPE = 'GET_DEVICE_TYPE';
//设备模式
var EQUIPMENT = exports.EQUIPMENT = 'EQUIPMENT';
//获取详细地址
var GET_ADDRESS_INFO = exports.GET_ADDRESS_INFO = 'GET_ADDRESS_INFO';

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "config.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/redux/config.jsx
// module id = 317
// module chunks = 0